import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import {useSnackBar} from '../../../contexts/snack-bar/context';
import {EntityUserCarePlansRepository} from '../../../repositories/entity-user-care-plans';
import DeleteResourceConfirmationModal from '../../delete-resource-confirmation-modal';
import {EntityTemplatesRepository} from '../../../repositories/entity-templates';
import {useParams} from 'react-router-dom';

interface DeleteActivityGroupEntryConfirmationProps {
  open: boolean;
  entryId: string;
  activitiesGroupName: string;
  seniorUserId?: string;
  activitiesSectorId: string;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteActivityGroupEntryConfirmation = ({
  open,
  entryId,
  activitiesGroupName,
  seniorUserId,
  activitiesSectorId,
  onDelete,
  onClose,
}: DeleteActivityGroupEntryConfirmationProps) => {
  let {entityId, templateId}: {entityId: string; templateId: string} = useParams();
  const {t} = useTranslation();
  const snackBarContext = useSnackBar();
  const handleGroupEntryDelete = async () => {
    if (seniorUserId) {
      EntityUserCarePlansRepository.instance
        .removeActivitiesGroupOnCarePlan(entityId, seniorUserId, activitiesSectorId, entryId)
        .then((_response) => {
          // Show Toast
          snackBarContext.setOfficeToastNotification({
            severity: 'success',
            message: t(translations.activities_group_entry.snackbar.delete.success),
          });

          // Notify
          onDelete();

          // Handle modal close side-effect
          onClose();
        })
        .catch((_error) => {
          // Show Toast
          snackBarContext.setOfficeToastNotification({
            severity: 'error',
            message: t(translations.activities_group_entry.snackbar.delete.error),
          });
        });
    } else {
      EntityTemplatesRepository.instance
        .deleteTemplateActivityGroup(entityId, templateId, entryId)
        .then((_response) => {
          // Show Toast
          snackBarContext.setOfficeToastNotification({
            severity: 'success',
            message: t(translations.activities_group_entry.snackbar.delete.success),
          });

          // Notify
          onDelete();

          // Handle modal close side-effect
          onClose();
        })
        .catch((_error) => {
          // Show Toast
          snackBarContext.setOfficeToastNotification({
            severity: 'error',
            message: t(translations.activities_group_entry.snackbar.delete.error),
          });
        });
    }
  };

  return (
    <DeleteResourceConfirmationModal
      id="confirm-delete-activity-group-entry-dialog"
      open={open}
      title={t(translations.activities_group_entry.modals.confirm_delete.title, {
        name: activitiesGroupName,
      })}
      description={t(translations.activities_group_entry.modals.confirm_delete.copy.title, {
        type: `"${activitiesGroupName}"`,
      })}
      cannotBeUndoneMessage={t(
        translations.activities_group_entry.modals.confirm_delete.copy.subtitle
      )}
      onCancel={onClose}
      onConfirm={handleGroupEntryDelete}
    />
  );
};
